<template>
  <div style="background: white">
    <Header :tabbarBoxFixed="tabbarBoxFixed"></Header>
    <router-view
      :scrollValue="scrollValue"
      :tabbarBoxFixed="tabbarBoxFixed"
    ></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/utils/flexible.js";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { reactive, ref, provide } from "vue";
// import './assets/style/common.scss'

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  setup() {
    var tabbarBoxFixed = ref(false);
    var scrollValue = ref(0);
    const handleScroll = () => {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      scrollValue.value = scrollTop;
      if (scrollTop > 90) {
        tabbarBoxFixed.value = true;
      } else {
        tabbarBoxFixed.value = false;
        console.log("当前滚动条位置:", tabbarBoxFixed.value);
      }
    };
    window.addEventListener("scroll", handleScroll, true);
    return {
      handleScroll,
      tabbarBoxFixed,
      scrollValue,
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
